"use strict";

var _regeneratorRuntime = require("/Users/nightmail/Documents/SourceCode/codb.io/web/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/Users/nightmail/Documents/SourceCode/codb.io/web/node_modules/@babel/runtime/helpers/asyncToGenerator");

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var app_1 = __importDefault(require("firebase/app"));

var Auth = __importStar(require("./auth"));

var firebase_1 = require("../../configs/firebase");

function getByToken(_x) {
  return _getByToken.apply(this, arguments);
}

function _getByToken() {
  _getByToken = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee(token) {
    var userId, querySnapshot;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return Auth.getUserId();

          case 2:
            userId = _context.sent;
            _context.next = 5;
            return app_1.default.firestore().collection(firebase_1.CN_PUSH_TOKENS).where('token', '==', token).where('user_id', '==', userId).limit(1).get();

          case 5:
            querySnapshot = _context.sent;

            if (!querySnapshot.empty) {
              _context.next = 10;
              break;
            }

            return _context.abrupt("return", null);

          case 10:
            return _context.abrupt("return", querySnapshot.docs[0]);

          case 11:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _getByToken.apply(this, arguments);
}

exports.getByToken = getByToken;

function checkIfExist(_x2) {
  return _checkIfExist.apply(this, arguments);
}

function _checkIfExist() {
  _checkIfExist = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee2(token) {
    var docSnapshot;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return getByToken(token);

          case 2:
            docSnapshot = _context2.sent;
            return _context2.abrupt("return", !!docSnapshot);

          case 4:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _checkIfExist.apply(this, arguments);
}

exports.checkIfExist = checkIfExist;

function create(_x3) {
  return _create.apply(this, arguments);
}

function _create() {
  _create = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee3(info) {
    var userId;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return Auth.getUserId();

          case 2:
            userId = _context3.sent;
            _context3.next = 5;
            return app_1.default.firestore().collection(firebase_1.CN_PUSH_TOKENS).add(Object.assign({}, info, {
              user_id: userId
            }));

          case 5:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return _create.apply(this, arguments);
}

exports.create = create;

function deleteMyTokens() {
  return _deleteMyTokens.apply(this, arguments);
}

function _deleteMyTokens() {
  _deleteMyTokens = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee4() {
    var userId, querySnapshot, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, doc;

    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _context4.next = 2;
            return Auth.getUserId();

          case 2:
            userId = _context4.sent;
            _context4.next = 5;
            return app_1.default.firestore().collection(firebase_1.CN_PUSH_TOKENS).where('user_id', '==', userId).get();

          case 5:
            querySnapshot = _context4.sent;
            _iteratorNormalCompletion = true;
            _didIteratorError = false;
            _iteratorError = undefined;
            _context4.prev = 9;
            _iterator = querySnapshot.docs[Symbol.iterator]();

          case 11:
            if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
              _context4.next = 18;
              break;
            }

            doc = _step.value;
            _context4.next = 15;
            return app_1.default.firestore().collection(firebase_1.CN_PUSH_TOKENS).doc(doc.id).delete();

          case 15:
            _iteratorNormalCompletion = true;
            _context4.next = 11;
            break;

          case 18:
            _context4.next = 24;
            break;

          case 20:
            _context4.prev = 20;
            _context4.t0 = _context4["catch"](9);
            _didIteratorError = true;
            _iteratorError = _context4.t0;

          case 24:
            _context4.prev = 24;
            _context4.prev = 25;

            if (!_iteratorNormalCompletion && _iterator.return != null) {
              _iterator.return();
            }

          case 27:
            _context4.prev = 27;

            if (!_didIteratorError) {
              _context4.next = 30;
              break;
            }

            throw _iteratorError;

          case 30:
            return _context4.finish(27);

          case 31:
            return _context4.finish(24);

          case 32:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4, null, [[9, 20, 24, 32], [25,, 27, 31]]);
  }));
  return _deleteMyTokens.apply(this, arguments);
}

exports.deleteMyTokens = deleteMyTokens;

function deleteByToken(_x4) {
  return _deleteByToken.apply(this, arguments);
}

function _deleteByToken() {
  _deleteByToken = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee5(token) {
    var userId, querySnapshot, _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, doc;

    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            _context5.next = 2;
            return Auth.getUserId();

          case 2:
            userId = _context5.sent;
            _context5.next = 5;
            return app_1.default.firestore().collection(firebase_1.CN_PUSH_TOKENS).where('user_id', '==', userId).where('token', '==', token).get();

          case 5:
            querySnapshot = _context5.sent;
            _iteratorNormalCompletion2 = true;
            _didIteratorError2 = false;
            _iteratorError2 = undefined;
            _context5.prev = 9;
            _iterator2 = querySnapshot.docs[Symbol.iterator]();

          case 11:
            if (_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done) {
              _context5.next = 18;
              break;
            }

            doc = _step2.value;
            _context5.next = 15;
            return app_1.default.firestore().collection(firebase_1.CN_PUSH_TOKENS).doc(doc.id).delete();

          case 15:
            _iteratorNormalCompletion2 = true;
            _context5.next = 11;
            break;

          case 18:
            _context5.next = 24;
            break;

          case 20:
            _context5.prev = 20;
            _context5.t0 = _context5["catch"](9);
            _didIteratorError2 = true;
            _iteratorError2 = _context5.t0;

          case 24:
            _context5.prev = 24;
            _context5.prev = 25;

            if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
              _iterator2.return();
            }

          case 27:
            _context5.prev = 27;

            if (!_didIteratorError2) {
              _context5.next = 30;
              break;
            }

            throw _iteratorError2;

          case 30:
            return _context5.finish(27);

          case 31:
            return _context5.finish(24);

          case 32:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5, null, [[9, 20, 24, 32], [25,, 27, 31]]);
  }));
  return _deleteByToken.apply(this, arguments);
}

exports.deleteByToken = deleteByToken;